import React from "react";
import { Button, Container, Row, Col,Card } from "reactstrap";
import { Link } from "react-router-dom";

export default function AssessNotFound(props) {
  const style_h1 = {
    "font-size": "3.75rem !important"
  };
  const style_span = {
    "margin-bottom": "2.5rem",
    "line-height": "1.4",
    "font-size": "1.25em"
  };

  return (
    <div className="app flex-row align-items-center">
      <Container>
        <Card>
        <Row className="justify-content-center mt-5">
          <Col md="6">
            <h1 style={style_h1}>OOPS! PAGE NOT FOUND.</h1>
            <span style={style_span}>
              {" "}
              Sorry! It seems like we can't find what you're looking for at this
              URL. Please check the link you used.
            </span>
          </Col>{" "}
        </Row>
        <Row className="justify-content-center mb-5">
          <Col md="2" className="mt-5">
            <Link to="/signin">
              <Button color="primary" className="px-4">
                Go Login
              </Button>
            </Link>
          </Col>
        </Row>
        </Card>
      </Container>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Assessment/AssessNotFound.js